import React, { useEffect, useState } from "react";
import styles from "../../../../styles/components/messageContentModal.module.scss";
import ModalWrapper from "../../../../ui/ModalWrapper/ModalWrapper";
import { Box } from "@mui/system";
import { Button } from "@mui/material";
import { useMutation } from "react-query";
import { getCurrentUTCDateTime } from "../../../../lib/functions/utils.lib";
import { createNote } from "../../../../api/functions/note.api";
import assest from "../../../../json/assest";

const AdminNoteUpdateModal = ({
  modalTitle,
  modalSubject,
  open,
  onClose,
  data,
  refetchNote,
  addKey,
  receiver_role,
}) => {
  const [note, setNote] = useState("");

  const [utcDateTime, setUtcDateTime] = useState(getCurrentUTCDateTime());

  const { mutate } = useMutation(createNote, {
    onSuccess: (data) => {
      console.warn("data", data);
      refetchNote();
    },
    onError: (error) => {
      // console.warn("error", error);
    },
  });
  // console.warn("data", data);

  const handleAddNote = () => {
    console.warn("receiver_role", receiver_role);
    if (note) {
      mutate({
        note,
        note_key: addKey,
        video_id: data.id,
        role: receiver_role,
      });
    }
    setNote("");
    onClose();
  };

  useEffect(() => {
    const timerId = setInterval(() => {
      setUtcDateTime(getCurrentUTCDateTime());
    }, 5000);

    // Clear the timer when the component unmounts
    return () => clearInterval(timerId);
  }, []);
  return (
    <>
      <ModalWrapper
        open={open}
        onClose={onClose}
        handleClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="rejectedModal"
      >
        <Box className={styles.messageModal}>
          <Box className={styles.messageModalHeader}>
            <h4>{modalTitle}</h4>
            <p>
              <span>Date:</span> {utcDateTime}
            </p>
          </Box>

          <Box className={styles.messageModalBody}>
            <Box className={styles.messageInput}>
              <label>{modalSubject}</label>
              <textarea
                value={note}
                onChange={(e) => setNote(e.target.value)}
              ></textarea>
            </Box>
            <Box className="attachFileinput">
              <input type="file" id="upload" hidden />
              <label htmlFor="upload">
                <img src={assest.attachIcon} width={13} height={15} alt="" />{" "}
                Attach a file
              </label>
            </Box>
          </Box>

          <Box className={styles.messageModalFooter}>
            <Button onClick={onClose}>Cancel</Button>
            <Button onClick={handleAddNote} className={styles.active}>
              Save
            </Button>
          </Box>
        </Box>
      </ModalWrapper>
    </>
  );
};

export default AdminNoteUpdateModal;
